import React, { useEffect, useState } from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { Link, useNavigate } from "react-router-dom";
import PageHeader from "../Components/PageHeader";
import SignUpTabs from "../Components/SignUpTabs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { signupCity, signupCountry, signupStates } from "../network/Network";

const PhysicianSignUp = () => {
	const navigate = useNavigate();
	const [loading, setLoading] = useState(false);
	const [formErrors, setFormErrors] = useState([]);
	const [getCountry, setGetcountry] = useState([]);
	const [getCountryid, setGetCountryid] = useState({});
	const [getCityid, setGetCityid] = useState({});
	const [getCity, setGetCity] = useState([]);
	const [getState, setGetState] = useState([]);
	const [getStateid, setGetStateid] = useState({});
	const [userData, setUserData] = useState({
		first_name: "",
		last_name: "",
		countryCode: "",
		phone: "",
		email: "",
		password: "",
		city: "",
		state: "",
		confirm_password: "",
		zip_code: "",
		country: "",
		address_type: "",
		address: "",
	});
	console.log(userData, "userData");
	// eye
	const [passwordVisibility, setPasswordVisibility] = useState({
		firstPassword: false,
		secondPassword: false,
	});

	const togglePasswordVisibility = (field) => {
		setPasswordVisibility((prevVisibility) => ({
			...prevVisibility,
			[field]: !prevVisibility[field],
		}));
	};
	//   Input Handler
	function handleChange(e) {
		const value = e.target.value;
		setUserData({ ...userData, [e.target.name]: value });
	}
	// ================

	const handleCountryChange = (e) => {
		const selectedCountryId = e.target.value;
		const selectedCountryName =
			e.target.options[e.target.selectedIndex].getAttribute("data-name");
		let countryObj = {
			id: selectedCountryId,
			name: selectedCountryName,
		};
		setGetCountryid(countryObj);
	};

	const handleStateChange = (e) => {
		const selectedStateId = e.target.value;
		const selectedStateName =
			e.target.options[e.target.selectedIndex].getAttribute("data-name");
		let StateObj = {
			id: selectedStateId,
			name: selectedStateName,
		};
		setGetStateid(StateObj);
	};

	const handleCityChange = (e) => {
		const selectedCityId = e.target.value;
		const selectedCityName =
			e.target.options[e.target.selectedIndex].getAttribute("data-name");
		let CityObj = {
			id: selectedCityId,
			name: selectedCityName,
		};
		setGetCityid(CityObj);
	};

	// Country API call
	useEffect(() => {
		signupCountry().then((res) => {
			setGetcountry(res?.data?.data);
		});
	}, []);

	// State API call based on selected country
	useEffect(() => {
		if (getCountryid) {
			signupStates(getCountryid?.id)
				.then((res) => {
					setGetState(res?.data?.data);
				})
				.catch((err) => {});
		}
	}, [getCountryid]);

	// City API call based on selected state
	useEffect(() => {
		if (getStateid) {
			signupCity(getStateid?.id)
				.then((res) => {
					setGetCity(res?.data?.data);
				})
				.catch((err) => {});
		}
	}, [getStateid]);

	// On Submit Handler
	const SubmitHandler = (e) => {
		e.preventDefault();

		const {
			first_name,
			last_name,
			phone,
			countryCode,
			email,
			password,
			city,
			state,
			confirm_password,
			zip_code,
			country,
			address_type,
			address,
		} = userData;

		let isValid = true;
		const errors = {};

		// Validate First Name
		if (!first_name) {
			if (!errors.first_name) errors.first_name = [];
			errors.first_name.push("First Name is required");
			isValid = false;
		}

		// Validate Last Name
		if (!last_name) {
			if (!errors.last_name) errors.last_name = [];
			errors.last_name.push("Last Name is required");
			isValid = false;
		}

		// Validate Phone Number
		if (!countryCode) {
			if (!errors.phone) errors.phone = [];
			errors.phone.push("Country code is required");
			isValid = false;
		}
		if (!phone) {
			if (!errors.phone) errors.phone = [];
			errors.phone.push("Phone is required");
			isValid = false;
		} else if (phone.length < 8 || phone.length > 10) {
			if (!errors.phone) errors.phone = [];
			errors.phone.push("Phone number must be between 8 to 12 digits");
			isValid = false;
		}

		// Validate Email
		if (!email) {
			if (!errors.email) errors.email = [];
			errors.email.push("Email is required");
			isValid = false;
		} else if (!/\S+@\S+\.\S+/.test(email)) {
			if (!errors.email) errors.email = [];
			errors.email.push("Email is invalid");
			isValid = false;
		}

		// Validate Password
		if (!password) {
			if (!errors.password) errors.password = [];
			errors.password.push("Password is required");
			isValid = false;
		} else if (password.length < 8) {
			if (!errors.password) errors.password = [];
			errors.password.push("Password must be at least 8 characters long");
			isValid = false;
		}

		// Validate Confirm Password
		if (!confirm_password) {
			if (!errors.confirm_password) errors.confirm_password = [];
			errors.confirm_password.push("Confirm Password is required");
			isValid = false;
		} else if (password !== confirm_password) {
			if (!errors.confirm_password) errors.confirm_password = [];
			errors.confirm_password.push("Passwords do not match");
			isValid = false;
		}

		// Validate Address
		if (!address) {
			if (!errors.address) errors.address = [];
			errors.address.push("Address is required");
			isValid = false;
		}

		if (!getCountryid) {
			errors.country = ["Country is required"];
			isValid = false;
		}
		if (!getCityid) {
			errors.city = ["City is required"];
			isValid = false;
		}
		if (!getStateid) {
			errors.state = ["State is required"];
			isValid = false;
		}

		// Validate state
		if (!zip_code) {
			if (!errors.zip_code) errors.zip_code = [];
			errors.zip_code.push("Zip Code/Postal Code is required");
			isValid = false;
		} else if (zip_code.length < 5) {
			if (!errors || !errors.zip_code) {
				if (!errors) errors = {};
				errors.zip_code = [];
			}
			errors.zip_code.push("zip must be 5 digits");
			isValid = false;
		}

		setFormErrors(errors);

		if (isValid) {
			// Navigate only if validation is successful
			navigate("/physician-signup-detail", {
				state: {
					first_name,
					last_name,
					phone,
					countryCode,
					email,
					password,
					getCityid,
					getStateid,
					confirm_password,
					zip_code,
					getCountryid,
					address_type,
					address,
				},
			});
		}
		// else {
		//   setTimeout(() => {
		//     setFormErrors({});
		//   }, 3000);
		// }
	};
	// ==================

	return (
		<>
			<Header />
			<PageHeader pagename="SignUp" />
			<section className="signup">
				<div className="container">
					<div className="row">
						<div className="col-lg-6 mx-auto">
							<div className="signup-wrappper">
								<h2 className="main-heading-font dark-color  level-2 text-center mt-3  mb-4">
									Sign up
								</h2>
								<div className="row mt-3">
									<div className="col-lg-12">
										<div className="d-flex align-items-center justify-content-center">
											<SignUpTabs />
										</div>
									</div>
								</div>
								<form>
									<div className="row">
										<div className="form-group col-lg-6">
											<label htmlFor="">
												<h5 className="primary-medium-font level-7 ">
													First Name
												</h5>
												<input
													type="text"
													className="form-control"
													id="firstName"
													placeholder=" First Name"
													name="first_name"
													onChange={handleChange}
													value={userData?.first_name}
												/>
												<p className="forms-error">{formErrors?.first_name}</p>
											</label>
										</div>
										<div className="form-group col-lg-6">
											<label htmlFor="">
												<h5 className="primary-medium-font level-7 ">
													Last Name
												</h5>
												<input
													type="text"
													className="form-control"
													id="firstName"
													placeholder=" Last Name"
													name="last_name"
													onChange={handleChange}
													value={userData?.last_name}
												/>
												<p className="forms-error">{formErrors?.last_name}</p>
											</label>
										</div>
									</div>
									<div className="row">
										<div className="form-group col-lg-12">
											<label htmlFor="">
												<h5 className="primary-medium-font level-7 ">Email</h5>
												<input
													type="email"
													className="form-control"
													id="firstName"
													placeholder=" Email"
													name="email"
													value={userData?.email}
													onChange={handleChange}
												/>
												<p className="forms-error">{formErrors?.email}</p>
											</label>
										</div>
									</div>
									<div className="row">
										<div className="form-group col-lg-12">
											<label htmlFor="">
												<h5 className="primary-medium-font level-7 ">
													Work Contact
												</h5>
												<div className="input-group">
													<select
														className="form-control"
														style={{
															maxWidth: "100px",
															borderRadius: "80px 0 0px 80px",
															border: "1px solid #869b96",
															background: "transparent",
														}}
														value={userData?.countryCode}
														name="countryCode"
														onChange={handleChange}
													>
														<option value="+1">+1 (USA)</option>
														<option value="+44">+44 (UK)</option>
													</select>
													<input
														type="number"
														className="form-control"
														id="firstName"
														placeholder="Enter Phone"
														name="phone"
														value={userData?.phone}
														onChange={handleChange}
													/>
												</div>
												<p className="forms-error">{formErrors?.phone}</p>
											</label>
										</div>
									</div>
									<div className="row">
										<div className="form-group col-lg-12">
											<label htmlFor="">
												<h5 className="primary-medium-font level-7 ">
													Work Address{" "}
												</h5>
												<input
													type="text"
													className="form-control"
													id="firstName"
													placeholder="Enter Work Address"
													name="address"
													value={userData?.address}
													onChange={handleChange}
												/>
												<p className="forms-error">{formErrors?.address}</p>
											</label>
										</div>
									</div>
									<div className="row">
										<div className="form-group col-lg-12 mb-3">
											<div className="country_dv">
												<h5 className="primary-medium-font level-7 ">
													Country
												</h5>
												<select
													id="countrySelect"
													onChange={handleCountryChange}
												>
													<option>Choose a country</option>
													{getCountry?.map((country) => (
														<option
															key={country?.id}
															value={country?.id}
															data-name={country?.name}
														>
															{country?.name}
														</option>
													))}
												</select>
											</div>
											<p className="forms-error">{formErrors?.country}</p>
										</div>

										<div className="form-group col-lg-12 mb-3">
											<div className="country_dv">
												<h5 className="primary-medium-font level-7 ">State</h5>

												<select id="idstateSelect" onChange={handleStateChange}>
													<option>Choose a state</option>
													{getState?.map((state) => (
														<option
															key={state?.id}
															value={state?.id}
															data-name={state?.name}
														>
															{state?.name}
														</option>
													))}
												</select>
											</div>
											<p className="forms-error">{formErrors?.state}</p>
										</div>
										<div className="form-group col-lg-12 mb-3">
											<div className="country_dv">
												<h5 className="primary-medium-font level-7 ">City</h5>

												<select id="idstateSelect" onChange={handleCityChange}>
													<option>Choose a city</option>
													{getCity?.map((city) => (
														<option
															key={city?.id}
															value={city?.id}
															data-name={city?.name}
														>
															{city?.name}
														</option>
													))}
												</select>
											</div>
											<p className="forms-error">{formErrors?.city}</p>
										</div>

										<div className="form-group col-lg-12">
											<label htmlFor="">
												<h5 className="primary-medium-font level-7 ">
													Zip Code/Postal Code
												</h5>

												<input
													type="number"
													className="form-control"
													id="firstName"
													placeholder="Zip Code/Postal Code"
													name="zip_code"
													value={userData?.zip_code}
													onChange={handleChange}
												/>
												<p className="forms-error">{formErrors?.zip_code}</p>
											</label>
										</div>
									</div>
									<div className="row">
										<div className="form-group col-lg-12">
											<label htmlFor="firstPassword">
												<h5 className="primary-medium-font level-7">
													Password
												</h5>
												<div className="password-container">
													<input
														type={
															passwordVisibility.firstPassword
																? "text"
																: "password"
														}
														className="form-control"
														id="firstPassword"
														placeholder="********"
														name="password"
														value={userData?.password}
														onChange={handleChange}
													/>
													<p className="forms-error">{formErrors?.password}</p>
													<span
														className="eye-icon"
														onClick={() =>
															togglePasswordVisibility("firstPassword")
														}
													>
														<FontAwesomeIcon
															icon={
																passwordVisibility.firstPassword
																	? faEyeSlash
																	: faEye
															}
														/>
													</span>
												</div>
											</label>
										</div>
									</div>
									<div className="row">
										<div className="form-group col-lg-12">
											<label htmlFor="secondPassword">
												<h5 className="primary-medium-font level-7">
													Confirm Password
												</h5>
												<div className="password-container">
													<input
														type={
															passwordVisibility.secondPassword
																? "text"
																: "password"
														}
														className="form-control"
														id="secondPassword"
														placeholder="********"
														name="confirm_password"
														value={userData?.confirm_password}
														onChange={handleChange}
													/>
													<p className="forms-error">
														{formErrors?.confirm_password}
													</p>
													<span
														className="eye-icon"
														onClick={() =>
															togglePasswordVisibility("secondPassword")
														}
													>
														<FontAwesomeIcon
															icon={
																passwordVisibility.secondPassword
																	? faEyeSlash
																	: faEye
															}
														/>
													</span>
												</div>
											</label>
										</div>
									</div>
									<Link
										className="btn wrapper-btn-main w-100 log-in mt-3 level-7 primary-regular-font text-decoration-none"
										to=""
									>
										<span
											onClick={(e) => SubmitHandler(e)}
											className="bg-wrapper w-100"
										>
											Proceed to Next Step
										</span>
									</Link>
									<h4 className=" level-7 text-center mt-3  primary-regular-font text-decoration-none extra-color-1">
										Already have an account?{" "}
										<Link
											to="/sign-in"
											className="header-link level-7 link-here primary-medium-font text-decoration-none extra-color-1"
										>
											Sign In
										</Link>
									</h4>
								</form>
							</div>
						</div>
						<h4 className=" level-7 text-center mt-3  primary-regular-font text-decoration-none extra-color-1">
							By Becoming a member, you agree to our{" "}
							<Link
								to="/terms-of-service"
								className="header-link level-7 link-here primary-medium-font text-decoration-none extra-color-1"
							>
								Terms & Conditions
							</Link>
						</h4>
					</div>
				</div>
			</section>
			<Footer />
		</>
	);
};

export default PhysicianSignUp;
